import { useState } from 'react';

import Form from 'components/Form';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import SectionTitle from '../../components/SectionTitle';

import { Box, MenuItem } from '@mui/material';

interface Props extends IFormRegister, IFormValues, IFormWatch {
  disabled?: boolean;
  time: null | string;
  setTime: (time: null | string) => void;
}

const NewInfo = (props: Props) => {
  const { disabled, register, watch, time, setTime } = props;

  const [damageEtc, setDamageEtc] = useState(0);
  const [intentionalEtc, setIntentionalEtc] = useState(0);
  const [diseaseEtc, setDiseaseEtc] = useState(0);
  const [postureEtc, setintentionalEtc] = useState(0);

  const [methodEtc, setMethodEtc] = useState(0);

  const contents = [
    {
      label: '氣道',
      element: (
        <Box display="flex">
          <Form.MuiTextField
            select
            required={false}
            {...register('emergency_patient_information.symptom')}
          >
            <MenuItem value="patent">通畅</MenuItem>
            <MenuItem value="compromised">受损</MenuItem>
          </Form.MuiTextField>
        </Box>
      ),
    },
    {
      label: '呼吸',
      element: (
        <Box display="flex">
          <Form.MuiTextField
            select
            required={false}
            {...register('emergency_patient_information.etc_symptom')}
          >
            <MenuItem value="no">无呼吸窘迫</MenuItem>
            <MenuItem value="mild">轻度窘迫</MenuItem>
            <MenuItem value="moderate">中度窘迫</MenuItem>
            <MenuItem value="severe">严重窘迫</MenuItem>
          </Form.MuiTextField>
        </Box>
      ),
    },
    {
      label: '呼吸音',
      element: (
        <Box display="flex">
          <Form.MuiTextField
            select
            required={false}
            {...register('emergency_patient_information.damage')}
            onChange={e => {
              if (e.target.value === 'other') setDamageEtc(1);
              else setDamageEtc(0);
            }}
          >
            <MenuItem value="clear">双侧清晰平等</MenuItem>
            <MenuItem value="crackles">啰音</MenuItem>
            <MenuItem value="wheezes">喘鸣</MenuItem>
            <MenuItem value="other">其他</MenuItem>
          </Form.MuiTextField>
          {damageEtc ? (
            <Form.MuiTextField
              {...register('emergency_patient_information.ktas')}
              placeholder="請輸入"
              sx={{ marginLeft: '5px' }}
            />
          ) : null}
        </Box>
      ),
    },
    {
      label: '循环',
      element: (
        <Form.MuiTextField
          {...register('emergency_patient_information.intentional')}
        />
      ),
    },
    {
      label: '水化状态',
      element: (
        <Box display="flex">
          <Form.MuiTextField
            select
            required={false}
            {...register('emergency_patient_information.medical_conditions')}
          >
            <MenuItem value="well">水分充足</MenuItem>
            <MenuItem value="mild">轻度脱水</MenuItem>
            <MenuItem value="moderate">中度脱水</MenuItem>
            <MenuItem value="severe">严重脱水</MenuItem>
          </Form.MuiTextField>
        </Box>
      ),
    },
    {
      label: '皮肤',
      element: (
        <Form.MuiTextField
          {...register('emergency_patient_information.motor')}
        />
      ),
    },
    {
      label: '神经系统',
      element: (
        <Form.MuiTextField
          {...register('emergency_patient_information.consciousness')}
        />
      ),
    },
    {
      label: '格拉斯哥昏迷评分',
      element: (
        <Form.MuiTextField {...register('emergency_patient_information.gcs')} />
      ),
    },
    {
      label: '瞳孔',
      element: (
        <Form.MuiTextField
          {...register('emergency_patient_information.pupil')}
        />
      ),
    },
    {
      label: '疼痛等级',
      element: (
        <Form.MuiTextField {...register('emergency_patient_information.nrs')} />
      ),
    },
    {
      label: '过敏',
      element: (
        <Form.MuiTextField
          {...register('emergency_patient_information.allergy')}
        />
      ),
    },
    {
      label: '分诊',
      element: (
        <Form.MuiTextField
          {...register('emergency_patient_information.history')}
        />
      ),
    },
  ];

  return (
    <>
      <SectionTitle title="评估" />
      <RowContainer xs={12}>
        {contents.map(({ label, element }) => (
          <>
            <RowContent
              title={label}
              titleRatio={1}
              childrenRatio={label === 'surgical position' ? 5 : 2}
            >
              {element}
            </RowContent>
          </>
        ))}
      </RowContainer>
    </>
  );
};

export default NewInfo;
